import ws from '@/api/ws'

const BUBBLE_MS = 3000
const MAX_LEN = 100

export default {
  data() {
    return {
      chatOpen: false,
      chatInput: '',
      chatBubbles: {},
      chatBubbleTimers: {}
    }
  },
  computed: {
    chatMessages() {
      return this.$store.state.multiplayer.messages
    },
    chatSelfId() {
      if (this.$store.state.playerId) return this.$store.state.playerId
      return (this.humanPlayer && this.humanPlayer.id) || ''
    }
  },
  beforeDestroy() {
    this.teardownChat()
  },
  methods: {
    setupChat() {
      this._offChat = ws.on('CHAT', this.handleIncomingChat)
      this._offChatHistory = ws.on('CHAT_HISTORY', this.handleChatHistory)
    },
    teardownChat() {
      if (this._offChat) this._offChat()
      if (this._offChatHistory) this._offChatHistory()
      this._offChat = null
      this._offChatHistory = null
      Object.keys(this.chatBubbleTimers).forEach(playerId => {
        clearTimeout(this.chatBubbleTimers[playerId])
      })
      this.chatBubbleTimers = {}
    },
    requestChatHistory() {
      const room = this.$store.state.multiplayer.room
      const playerId = this.$store.state.playerId
      if (!room || !playerId) return
      ws.send(`/app/room/${room.id}/chat/history`, { playerId })
    },
    handleChatHistory(msg) {
      const list = Array.isArray(msg && msg.payload) ? msg.payload : []
      this.$store.commit('multiplayer/SET_CHAT_MESSAGES', list)
    },
    handleIncomingChat(msg) {
      const payload = (msg && msg.payload) || {}
      if (!payload.id || !payload.text) return
      this.$store.commit('multiplayer/ADD_CHAT_MESSAGE', payload)
      this.showChatBubble(payload.playerId, payload.text)
    },
    showChatBubble(playerId, text) {
      if (!playerId || !text) return
      if (this.chatBubbleTimers[playerId]) clearTimeout(this.chatBubbleTimers[playerId])
      const token = Date.now()
      this.$set(this.chatBubbles, playerId, { text, token })
      this.chatBubbleTimers[playerId] = setTimeout(() => {
        const current = this.chatBubbles[playerId]
        if (current && current.token === token) {
          this.$delete(this.chatBubbles, playerId)
        }
        delete this.chatBubbleTimers[playerId]
      }, BUBBLE_MS)
    },
    sendChat() {
      const text = (this.chatInput || '').trim().slice(0, MAX_LEN)
      if (!text) return
      const room = this.$store.state.multiplayer.room
      const online = this.$store.state.multiplayer.gameMode === 'online' && room
      if (online) {
        const playerId = this.$store.state.playerId
        if (!playerId || !ws.connected) return
        ws.send(`/app/room/${room.id}/chat`, { playerId, text })
        this.chatInput = ''
        return
      }
      const me = this.humanPlayer
      if (!me) return
      this.$store.commit('multiplayer/ADD_CHAT_MESSAGE', {
        id: `local-${Date.now()}`,
        playerId: me.id,
        playerName: me.name,
        text,
        timestamp: Date.now()
      })
      this.showChatBubble(me.id, text)
      this.chatInput = ''
    }
  }
}
